<template>
    <div class="hello-page-wrapper career-page-wrapper expert-page-wrapper" :class="{'bodyfont-unauth': !user}">
        <div class="featured main">
            <div class="container">
                <div  class="row margin-top-40">
                    <div  class="col-sm-5"><img  src="https://s3.amazonaws.com/assets.tonenetworks.com/images/experts/Ramani.jpg" class="img-responsive"></div>
                    <div  class="col-sm-7">
                        <div  class="row">
                            <div  class="experts">
                                <a href="https://www.tonenetworks.com/#/expert/19"><h2 > Dr. Ramani Durvasula </h2></a>
                                <p  class="title"> (Relationship Realist, Ph.D.) </p>
                                <p  class="desc">Dr. Ramani Durvasula is a licensed clinical psychologist in private practice and Professor of Psychology at California State University, Los Angeles, where she was named Outstanding Professor in 2012. She is also a Visiting Professor at the University of Johannesburg. She brings a wealth of expertise in relationships, sexuality, health and wellness, helping people reach their full potential in their relationships, jobs, and family time. <br>
                                    Dr. Ramani is a sought-after presenter for audiences ranging from adolescents to mental health professionals. She is involved in national governance in the field of psychology and served as chair of the Committee on Socioeconomic Status at the American Psychological Association and is a member of the Advisory Board of the Minority Fellowship Program of the American Psychological Association.<br>
                                    Dr. Ramani was co-host of Oxygen’s <i>My Shopping Addiction</i>, and has been featured on Bravo, Lifetime Movie Network, National Geographic, History Channel, Discovery, and in documentary films on health. She is a featured commentator on nearly every major television network, radio, print, and internet media. She is the author of numerous peer-reviewed journal articles, book chapters and papers; the modern relationship survival manual <i>Should I Stay or Should I Go: Surviving a Relationship With a Narcissist</i>; and <i>You Are WHY You Eat: Change Your Food Attitude, Change Your Life</i>. Dr. Ramani is currently at work on a new book about staying sane in our era of entitlement. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div  class="margin-top-40">
            <div  class="blog-section videossection clearfix">
                <div  class="row">
                    <div  class="col-md-12 margin-bottom-40">
                        <a href="https://www.tonenetworks.com/#/expert/19"><h2 class="text-center pinkh2">CLICK HERE FOR MORE ON Dr. Ramani Durvasula</h2></a>
                    </div>
                </div>
                <a href="https://www.tonenetworks.com/#/expert/19">
                    <div  class="row random-section-head yourFaves exceptionalsettings">
                        <div  class="col-xs-12 col-sm-6 col-md-4 bottom-margin"><img  src="https://cdn.jwplayer.com/thumbs/dWIRniaI-720.jpg" class="jw-img"> <!---->
                            <p  class="text-wrap-title cursor"><i  class="fa fa-play-circle-o"></i>Retail Therapy</p>
                            <!----> <!----> <!----></div>
                        <div  class="col-xs-12 col-sm-6 col-md-4 bottom-margin"><img  src="https://cdn.jwplayer.com/thumbs/tTLW0ntx-720.jpg" class="jw-img"> <!---->
                            <p  class="text-wrap-title cursor"><i  class="fa fa-play-circle-o"></i>How to Pick a Partner</p>
                            <!----> <!----> <!----></div>
                        <div  class="col-xs-12 col-sm-6 col-md-4 bottom-margin"><img  src="https://cdn.jwplayer.com/thumbs/m0jB57uy-720.jpg" class="jw-img"> <!---->
                            <p  class="text-wrap-title cursor"><i  class="fa fa-play-circle-o"></i>Channel Your Inner Leader</p>
                            <!----> <!----> <!----></div>
                    </div>
                </a>
            </div>
        </div>
        <!--<div class="random">-->
            <!--<div class="container">-->
                <!--<div class="margin-top-40">-->
                    <!--<div class="blog-section clearfix">-->
                        <!--<div class="row">-->
                            <!--<div class="col-md-12 margin-bottom-40" v-if="getExpert">-->
                                <!--<h2 class="text-center">{{getExpert[0].name}}'s videos</h2>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="slider responsive-slick-slider">-->
                            <!--<div v-for = "expertVideo in getExpertVideos">-->
                                <!--<div class="slide-player">-->
                                    <!--<img class="jw-img" :src="expertVideo.image" @click="setVideoPlayerObject(expertVideo.videoCode)" />-->
                                    <!--<p>-->
                                        <!---->
                                    <!--</p>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->
                            <!--&lt;!&ndash;<div class="col-md-12 margin-bottom-40">&ndash;&gt;-->
                                <!--&lt;!&ndash;<button class="btn btn-info btn-load-more btn-transparent btn-lg">Load More</button>&ndash;&gt;-->
                            <!--&lt;!&ndash;</div>&ndash;&gt;-->
                        <!--&lt;!&ndash;</div>&ndash;&gt;-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <modal v-if="showWatchVideoModal" class="watchVideoModal" effect="zoom" :value="showWatchVideoModal" @cancel="cancelModal()">
            <div slot="modal-header" class="watchVideoModalHeader">
                <a href="javascript:">
                    <img src="../assets/logo.svg" alt="LOGO">
                </a>
                <a href="javascript:" @click="cancelModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <jwplayer :data="currentPlayerID">Loading the player...</jwplayer>
                <p>
                    {{currentPlayerID.videoDescription}}
                </p>
            </div>
            <div slot="modal-footer"></div>
        </modal>
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayList.vue'
    import slick from 'slick-carousel'
    import { tabs, tab, modal } from 'vue-strap'
    import {mapGetters} from 'vuex'
    import $ from 'jquery'
    import store from '../store'
    import { dateHelpers } from '../helpers/dateHelpers.js'
    export default {
        name: 'expert',
        components: {
            jwplayer,
            'jwplaylist': JwPlayList,
            'tabs': tabs,
            'tab': tab,
            modal: modal
        },
        data: function () {
            return {
                activeTab: 0,
                expertEvent: '',
                expertMainVideo: '',
                showWatchVideoModal: false,
                currentPlayerID: '',
                currentVideoRef: '',
                newPlaylistName: '',
                videoAdded: false,
                videoRemoved: false,
                selectedVideo: 0,
                selecedPlaylist: 0,
                topVideos: [],
                seatReservation: {
                    userEventId: 0,
                    eventId: 0,
                    userId: 0,
                    status: 0,
                    isAnonymous: 0
                }
            }
        },
        mounted: function () {
//            this.store.commit('setExpert', {expert: null})
//            this.store.commit('setExpertVideos', {expertVideos: null})
//            // Get Expert Information
            this.$store.dispatch('GETEXPERT', this.$route.params.expertId).then(() => {
                if (this.getExpert) {
                    // Get Event List
                    this.$store.dispatch('GETEVENTLIST').then(() => {
                        if (this.getEventList) {
                            let expEvent = this.getEventList.filter(ev => {
                                return ev.expertId === this.getExpert[0].expertId
                            })
                            if (expEvent && expEvent.length > 0) {
                                this.expertEvent = expEvent[0]
                            }
                        }
                    })
                    // Get User Events
                    if (this.user) {
                        this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                        })
                    }
                }
               // console.log('expert', this.getExpert)
            })
            // Get Expert Videos
            this.$store.dispatch('GETEXPERTVIDEOS', this.$route.params.expertId).then(() => {
                if (this.getExpertVideos) {
                    this.topVideos = this.getExpertVideos.slice(0, 7)
                    console.log('top videos retreived', this.topVideos)
                    console.log('after status', this.getExpertVideos)
                    let mainVideo = this.getExpertVideos[0]
                    if (!this.expertEvent) {
                        this.expertMainVideo = {
                            video: mainVideo.sources[mainVideo.sources.length - 1].file,
                            title: mainVideo.title,
                            img: mainVideo.image,
                            playerID: new Date(),
                            tracks: mainVideo.tracks,
                            isMute: true,
                            showCaptions: true,
                            mediaId: mainVideo.mediaid
                        }
                    }
                }
            })
            this.$store.dispatch('GETEXPERTPLAYLIST', this.$route.params.expertId).then(() => {
            })
            // Get User Liked Videos
            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(() => {
                // this.charities = this.getAuthUserVideos
            })
            // Get User Playlists
            this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(() => {
                // this.charities = this.getAuthUserVideos
            })
            window.scrollTo(0, 0)
        },
        methods: {
            setVideoPlayerObject (videoObject) {
                if (videoObject.marketing) {
                    this.openModal(videoObject)
                } else {
                    if (this.user) {
                        this.$router.push('/watch/' + videoObject.videoCode)
                    } else {
                        if (sessionStorage.getItem('redirectPath')) {
                            sessionStorage.removeItem('redirectPath')
                            sessionStorage.setItem('redirectPath', `/watch/${videoObject.videoCode}`)
                        } else {
                            sessionStorage.setItem('redirectPath', `/watch/${videoObject.videoCode}`)
                        }
                        store.commit('setTriggerLogin', {loginStatus: true})
                    }
                    // this.$router.push(`/watch/${videoObject.videoCode}`)
                }
            },
            cancelModal () {
                var self = this
                var $ = window.jQuery
                setTimeout(function () {
                    self.showModal = false
                    self.showWatchVideoModal = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            openModal (mainVideoObj) {
                let self = this
                if (!this.expertEvent) {
                    if (self.currentVideoRef) {
//                        console.log('referenece found as: ', self.currentVideoRef)
                        window.jwplayer(self.currentVideoRef).pause(true)
                    } else {
                        self.currentVideoRef = window['currentVideoId']
                        window.jwplayer(self.currentVideoRef).pause(true)
//                        console.log('referenece not found as: ', self.currentVideoRef)
                    }
                    // window.jwplayer(window['currentVideoId']).pause(true)
                }
                this.currentPlayerID = {video: mainVideoObj.sources[mainVideoObj.sources.length - 1].file, title: mainVideoObj.title, img: mainVideoObj.image, playerID: new Date(), tracks: mainVideoObj.tracks, videoDescription: mainVideoObj.longdescription}
                this.showWatchVideoModal = true
                this.currentVideoDesc = mainVideoObj.description
            },
            getDateReference (dte, type) {
                let dt = new Date(dte)
                let dayStr, monStr
                let eDay = dt.getDate()
                let eHours = this.getHoursFormatted(dt)
                let eMonth = dt.getMonth() + 1
                let day
                // Set Day of Date
                if (dt.getDay() === 0) {
                    day = 'Sunday'
                } else if (dt.getDay() === 1) {
                    day = 'Monday'
                } else if (dt.getDay() === 2) {
                    day = 'Tuesday'
                } else if (dt.getDay() === 3) {
                    day = 'Wednesday'
                } else if (dt.getDay() === 4) {
                    day = 'Thursday'
                } else if (dt.getDay() === 5) {
                    day = 'Friday'
                } else if (dt.getDay() === 6) {
                    day = 'Saturday'
                } else {
                    day = ''
                }
                // Set Date Pattern
                if (eDay === 1) {
                    dayStr = '1st'
                } else if (eDay === 2) {
                    dayStr = '2nd'
                } else if (eDay === 3) {
                    dayStr = '3rd'
                } else if (eDay === 21) {
                    dayStr = '21st'
                } else if (eDay === 22) {
                    dayStr = '22nd'
                } else if (eDay === 23) {
                    dayStr = '23rd'
                } else if (eDay === 31) {
                    dayStr = '31st'
                } else {
                    dayStr = eDay + 'th'
                }
                // Set Month
                if (eMonth === 1) {
                    monStr = 'January'
                } else if (eMonth === 2) {
                    monStr = 'February'
                } else if (eMonth === 3) {
                    monStr = 'March'
                } else if (eMonth === 4) {
                    monStr = 'April'
                } else if (eMonth === 5) {
                    monStr = 'May'
                } else if (eMonth === 6) {
                    monStr = 'June'
                } else if (eMonth === 7) {
                    monStr = 'July'
                } else if (eMonth === 8) {
                    monStr = 'August'
                } else if (eMonth === 9) {
                    monStr = 'September'
                } else if (eMonth === 10) {
                    monStr = 'October'
                } else if (eMonth === 11) {
                    monStr = 'November'
                } else if (eMonth === 12) {
                    monStr = 'December'
                }
                if (type === 'btn') {
                    return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
                } else if (type === 'live') {
                    return monStr + ' ' + eDay
                } else if (type === 'live2') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else if (type === 'str') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else {
                    return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET'
                }
            },
            getHoursFormatted (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'pm' : 'am'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = hours + ':' + minutes + ' ' + ampm
                return strTime
            },
            isUserEntrolled (eventId) {
                if (this.getUserEvents) {
                    let filter = this.getUserEvents.filter(ev => {
                        return ev.eventId === eventId
                    })
                    if (filter && filter.length > 0) {
                        return true
                    }
                }
                return false
            },
            getMinutesBetweenDates (startDate, endDate) {
                var diff = endDate.getTime() - startDate.getTime()
                return (diff / 60000)
            },
            returnEasternTime () {
                let offset = -5
                if (dateHelpers.dstEnabled(new Date())) {
                    offset = -4.0
                }
                let clientDate = new Date()
                let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
                let serverDate = new Date(utc + (3600000 * offset))
                return serverDate
            },
            isEventToday (evtDate, endDate) {
                let eventDate = new Date(evtDate)
                let eventEndDate = new Date(endDate)
                let currentDate = this.returnEasternTime()
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= 15 && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            enrollUser (event) {
                this.seatReservation.eventId = event.eventId
                this.seatReservation.userId = this.user.userId
                this.seatReservation.status = '1'
                this.seatReservation.isAnonymous = '0'
                this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(() => {
                    this.$store.dispatch('GETALLEXPERTS').then(() => {
                    })
                    this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                    })
                })
            },
            addNewPlayList () {
                if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                    let payload = {}
                    payload.userId = this.user.userId
                    payload.title = this.newPlaylistName
                    this.$store.dispatch('CREATEPLAYLIST', {playlist: payload}).then(() => {
                        this.newPlaylistName = ''
                        // this.charities = this.getAuthUserVideos
                    })
                }
            },
            showPlaylistMenu (videoCode) {
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            hidePlaylistMenu (videoCode) {
                // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            setPlaylistVideoStatus (video, playlist, currentStatus) {
                let self = this
                self.selectedVideo = video.mediaid
                self.selectedPlaylist = playlist.playlistId
                if (currentStatus) { // Video is unSelected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userPlaylistId = playlist.playlistId
                    payload.userId = this.user.userId
                    this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                        self.videoAdded = false
                        self.videoRemoved = true
                    })
                } else { // Video is Selected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userId = this.user.userId
                    payload.userPlaylistId = playlist.playlistId
                    this.$store.dispatch('ADDVIDEOINPLAYLIST', {playlist: payload}).then(() => {
                        // this.charities = this.getAuthUserVideos
                        self.videoAdded = true
                        self.videoRemoved = false
                    })
                }
                setTimeout(() => {
                    self.videoAdded = false
                    self.videoRemoved = false
                }, 1500)
            },
            verifyPlaylistExists () {
                if (this.getUserPlaylists) {
                    let playlistsWithVideo = this.getUserPlaylists.filter(x => {
                        return x.userPlaylistVideos !== null
                    })
                    if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            verifyVideoExists (playlist, video) {
                let self = this
                if (this.getUserPlaylists) {
                    let findPlaylist = this.getUserPlaylists.filter(x => {
                        return x.playlistId === playlist.playlistId
                    })
                    if (findPlaylist && findPlaylist.length > 0) {
                        if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                            let videos = findPlaylist[0].userPlaylistVideos.filter(x => {
                                return x.videoCode === video.mediaid
                            })
                            if (videos && videos.length > 0) {
                                self.playlistHasVideo = true
                                return true
                            } else {
                                return false
                            }
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            getVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0 && exists[0].liked === '1') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            setVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0) {
                        if (exists[0].liked === '1') {
                            exists[0].liked = '0'
                        } else {
                            exists[0].liked = '1'
                        }
                        this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(() => {
                            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                        })
                    } else {
                        let logWatchedEntry = {
                            videoCode: videoObject.mediaid,
                            userId: this.user.userId,
                            playlistId: null,
                            playlistCode: null,
                            watched: 'N',
                            rating: null,
                            liked: '1',
                            durationWatched: 0,
                            thumbnailURL: null,
                            opinion: null
                        }
                        this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                        })
                    }
                }
            },
            verifyVideoStatus (videoCode) {
                if (this.getExpertVideos) {
                    let getStatus = this.topVideos.filter(x => {
                        return x.mediaid === videoCode
                    })
                    if (getStatus && getStatus.length > 0) {
                        console.log('video found - ', getStatus[0].title + ' - ' + getStatus[0].mediaid)
                        return true
                    } else {
                        console.log('video not found - ', videoCode)
                        return false
                    }
                }
            },
            createSlickCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                })
            }
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'user', 'isScrolled', 'getExpert', 'getExpertVideos', 'getEventList', 'getUserEvents', 'getVideosFlag', 'getExpertPlaylist', 'getUserPlaylists', 'getAuthUserVideos']
            )
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .expert-page-wrapper .main h2 {
        margin-top: 0;
    }
    h2.pinkh2{
        font-size: 29px;
        color: #f0617d !important;
        text-transform: uppercase;
        font-weight:700;
    }
    .expert-page-wrapper .random .blog-section h2.pinkh2{
        font-size: 29px;
        color: #f0617d !important;
        text-transform: uppercase;
    }
    .blog-section.videossection.clearfix .panel .panel-body > .col-md-12.margin-top-20.margin-bottom-40 {
        margin: 10px 0;
        padding: 0;
    }

    .blog-section.videossection.clearfix .panel .panel-body > .col-md-12.margin-top-20.margin-bottom-40 p {
        font-size: 15px;
    }

    .blog-section.videossection.clearfix .panel .panel-body > .col-md-12.margin-top-20.margin-bottom-40 > p > i.fa.fa-play-circle-o {
        position: relative;
        font-size: 25px;
        width: auto !important;
        color:black;
        margin-right:10px;
        top:3px
    }
    .blog-section.videossection.clearfix .panel .panel-body {
        cursor: pointer;
    }
    img.img-responsive {
        width: 100%;
    }
    .expert-page-wrapper .main img{height:auto;}
    .expert-page-wrapper .live-chat
    img.nostyle {
        width: auto;
        height: auto;
        max-width: 90%;
        float: left;
    }
    .experts h2 {
        margin-top: 0;
    }
    .pintlist-holder {padding: 0 0 50px;}
    ul.pink_container {
        padding: 20px;
        color: #f0617d;
        font-weight: 700;
        font-size: 18px;
        margin: 30px 0;
        border: 2px solid #f0617d;
        list-style: none;
    }

    ul.pink_container li {
        line-height: 1.3;
        padding: 0 0 10px;
    }
    .btn-group.plusicon {
        position: absolute;
        right: 50px;
        bottom: 0px;
        height: 29px;
        z-index:200;
    }
    li.divider {
        border-bottom: 1px solid #ddd;
        margin: 5px -15px;
    }

    button.dropdown-toggle.ellipsis.pull-right {
        background: transparent;
        border: 0 none transparent;
        padding: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right{
        font-size: 21px;
        top: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right li label{
        padding: 30px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+ ul li a {
        padding: 3px 15px;
        margin-bottom: 5px;
        display: block;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control {
        height: 30px;
        padding: 5px 30px 5px 5px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle {
        position: absolute;
        top: 6px;
        font-size:24px;
        right:20px;
        cursor: pointer;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+div + ul li label{
        position:relative;
    }
    button.dropdown-toggle.ellipsis.pull-right+ div + ul,
    button.dropdown-toggle.ellipsis.pull-right+ ul{
        left: 0;
        right: auto;
        width: 230px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 5px;
        top: 100%;
        position: absolute;
        z-index: 5000;
        list-style: none;
        text-align: left;
        padding: 15px;
    }
    .backdropformenu{
        position:fixed;
        z-index:4900;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: transparent;
    }
    .profile .tabContent .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        left: auto ;
        right: 0;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    label.notificationwithcheckboxes span{
        font-size: 10px;
    }

    span.removed {
        color: red;
    }
    span.added {
        color: #4caa98;
    }

    label.notificationwithcheckboxes {
        position: relative;
        display:block;
    }


    label.notificationwithcheckboxes {}
    .career-page-wrapper .featured .experts p{
        font-weight:normal;    }
    .row.yourFaves p.text-wrap-title.cursor {
        text-align: left;
        font-size: 15px;
        white-space: nowrap;
        font-weight: normal;
        line-height: 1.8;
        color: #5e5e5e;
        margin-top:10px;
        overflow:hidden;
        text-overflow:ellipsis;
    }

    .row.yourFaves p.text-wrap-title.cursor i.fa.fa-play-circle-o {
        position: relative;
        font-size: 25px;
        width: auto !important;
        color: black;
        margin-right: 10px;
        top: 3px;
    }
    .row.yourFaves hr {
        margin: 0;
    }

    .row.yourFaves p.right-heart-icon {
        text-align: right;
        top: 10px;
        position: relative;
        z-index: 100;
    }

    .row.random-section-head.yourFaves.exceptionalsettings
    p.text-wrap-title.cursor i.fa.fa-play-circle-o{
        height:20px !important;
    }

    .row.random-section-head.yourFaves.exceptionalsettings
    .plusicon.btn-group {
        bottom:15px;
    }
    @media(min-width:992px){
        .row.random-section-head.yourFaves.exceptionalsettings .col-xs-12.col-sm-6.col-md-4.bottom-margin:nth-of-type(3n + 1) {
            clear: left;
        }
    }
</style>



// WEBPACK FOOTER //
// DrRamani.vue?51db389a